import i18n from "@/i18n";
import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api } from "@/lib/api";
import PageHeader from "@/components/PageHeader";

const SECTIONS = [
    { key: "tasks", get label() { return i18n.t("ui.Search.SECTIONS.label_workflowTasks", "Workflow tasks"); }, to: "/workflow", field: "title" },
    { key: "recipes", get label() { return i18n.t("ui.Search.SECTIONS.label_recipes", "Recipes"); }, to: "/recipes", field: "name" },
    { key: "products", get label() { return i18n.t("ui.Search.SECTIONS.label_products", "Products"); }, to: "/inventory", field: "product_name" },
    { key: "suppliers", get label() { return i18n.t("ui.Search.SECTIONS.label_suppliers", "Suppliers"); }, to: "/suppliers", field: "name" },
    { key: "announcements", get label() { return i18n.t("ui.Search.SECTIONS.label_announcements", "Announcements"); }, to: "/announcements", field: "title" },
    { key: "restaurants", get label() { return i18n.t("ui.Search.SECTIONS.label_restaurants", "Restaurants"); }, to: "/settings", field: "name" },
];

export default function SearchPage() {
    const [params] = useSearchParams();
    const q = params.get("q") || "";
    const [results, setResults] = useState(null);

    useEffect(() => {
        if (!q) return;
        api.get("/search", { params: { q } }).then(({ data }) => setResults(data));
    }, [q]);

    return (
        <div className="px-6 lg:px-12 py-10 max-w-5xl mx-auto">
            <PageHeader showTitle title={i18n.t("ui.search.resultsFor", "Results for \"{{q}}\"", { q })} subtitle={i18n.t("ui.search.acrossTheWholePlatform", "Across the whole platform.")} />
            {!results ? (
                <div className="kop-card p-6 text-sm text-neutral-500">{i18n.t("ui.search.searching", "Searching…")}</div>
            ) : (
                <div className="space-y-8">
                    {SECTIONS.map((s) => (
                        <section key={s.key}>
                            <div className="flex items-baseline justify-between mb-3">
                                <h2 className="font-display text-xl font-bold">{s.label}</h2>
                                <span className="text-xs text-neutral-500">{results[s.key]?.length || 0} found</span>
                            </div>
                            {(results[s.key]?.length || 0) === 0 ? (
                                <div className="kop-card p-4 text-sm text-neutral-500">{i18n.t("ui.search.noResults", "No results.")}</div>
                            ) : (
                                <ul className="kop-card divide-y divide-neutral-100">
                                    {results[s.key].map((it, i) => (
                                        <li key={i} className="px-5 py-3 flex items-center justify-between text-sm">
                                            <span className="font-medium">{it[s.field]}</span>
                                            <Link to={s.to} className="text-xs text-neutral-500 hover:text-neutral-900 underline">{i18n.t("ui.search.open", "Open")}</Link>
                                        </li>
                                    ))}
                                </ul>
                            )}
                        </section>
                    ))}
                </div>
            )}
        </div>
    );
}
